import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { ParamsType, decodeResponse200, Response200Type, openapi_website_cms_changeOrderHeadlineCarousel } from 'src/api_openapi/generated/openapi_website_cms_changeOrderHeadlineCarousel';

export type HeadlineCarouselModelType = Response200Type;

const decode = (status: number, data: ResponseType): HeadlineCarouselModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface HeadlineCarouselTypeSubmitType {
    data: ParamsType['body'],
    collection_slug: ParamsType['collection_slug']
}

export const postOrderHeadlineCarousel = {
    browser: {
        params: (params: HeadlineCarouselTypeSubmitType): ParamsFetchType<HeadlineCarouselTypeSubmitType> => {
            return {
                type: MethodType.PUT,
                url: '/api-web/change-order-headline-carousel',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PUT,
        urlBrowser: '/api-web/change-order-headline-carousel',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<HeadlineCarouselTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_changeOrderHeadlineCarousel(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.data,
            collection_slug: params.req.body.collection_slug
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
